export default {"src":"/login-app/[GIT_HASH]/_next/static/media/shield.4f432a2b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};